(function () {
  if (customElements.get('hl-anchor-price')) return;

  var uid = 0;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  class HlAnchorPrice extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.hl-dc__info');
      this.tip = this.querySelector('.hl-dc__tip');
      if (!this.button || !this.tip) return;

      this.pinned = false;
      this.tip.id = this.tip.id || 'hl-dc-tip-' + ++uid;
      this.button.setAttribute('aria-describedby', this.tip.id);

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onDocPointer = this.onDocPointer.bind(this);
      this.onDocKey = this.onDocKey.bind(this);
      this.onOtherOpen = this.onOtherOpen.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      document.addEventListener('hl-anchor-price:open', this.onOtherOpen);
    }

    disconnectedCallback() {
      this.close();
      document.removeEventListener('hl-anchor-price:open', this.onOtherOpen);
    }

    onButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isOpen() && this.pinned) {
        this.close();
      } else {
        this.open(true);
      }
    }

    onEnter() {
      if (canHover.matches && !this.isOpen()) this.open(false);
    }

    onLeave() {
      if (canHover.matches && !this.pinned) this.close();
    }

    onDocPointer(event) {
      if (!this.contains(event.target)) this.close();
    }

    onDocKey(event) {
      if (event.key === 'Escape') {
        var hadFocus = this.contains(document.activeElement);
        this.close();
        if (hadFocus) this.button.focus();
      }
    }

    onOtherOpen(event) {
      if (event.detail !== this) this.close();
    }

    isOpen() {
      return !this.tip.hidden;
    }

    open(pinned) {
      this.pinned = pinned;
      if (this.isOpen()) return;
      document.dispatchEvent(new CustomEvent('hl-anchor-price:open', { detail: this }));
      this.tip.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      this.keepInViewport();
      document.addEventListener('pointerdown', this.onDocPointer, true);
      document.addEventListener('keydown', this.onDocKey);
    }

    close() {
      if (!this.tip) return;
      this.pinned = false;
      this.tip.hidden = true;
      this.tip.style.removeProperty('left');
      this.tip.classList.remove('hl-dc__tip--above');
      this.button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', this.onDocPointer, true);
      document.removeEventListener('keydown', this.onDocKey);
    }

    keepInViewport() {
      var gutter = 8;
      this.tip.classList.remove('hl-dc__tip--above');
      var tipRect = this.tip.getBoundingClientRect();
      var spaceAbove = this.button.getBoundingClientRect().top;
      if (tipRect.bottom > window.innerHeight - gutter && spaceAbove > tipRect.height + gutter * 2) {
        this.tip.classList.add('hl-dc__tip--above');
      }

      var vw = document.documentElement.clientWidth;
      var host = this.getBoundingClientRect();
      var btn = this.button.getBoundingClientRect();
      var width = this.tip.offsetWidth;
      var left = btn.left + btn.width / 2 - width / 2;
      left = Math.max(gutter, Math.min(left, vw - gutter - width));
      this.tip.style.left = left - host.left + 'px';
    }
  }

  customElements.define('hl-anchor-price', HlAnchorPrice);
})();
